import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import images from "../../../global-styles/images";
import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

const Tile = (props: any) => {
  const { image, label, tooltipText, count } = props;

  return (
    // <Grid item xs={12} sm={12} md={12} lg={2.4} xl={2.4} flexGrow={1}>
    <Grid item xs={12} sm={12} md={12} lg={3} xl={3} flexGrow={1}>
      <Paper
        sx={{
          p: "13px 0px 10px 16px",
          // pt: 3,
          margin: "auto",
          height: "100%",
          flexGrow: 1,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "#fff",
          boxShadow: "none",
          border: "1px solid #ccc",
          borderRadius: "8px",
          position: "relative",
          display: "flex",
        }}
      >
        <Grid
          sx={{
            flexGrow: 1,
            // pr: "40px",
            // pt: "20px",
          }}
        >
          <Typography
            sx={{
              color: "#727272",
              fontSize: "12px",
              display: "flex",
            }}
            variant="body2"
          >
            {label}&nbsp;
            <Tooltip title={tooltipText} placement="top">
              <HelpIcon
                sx={{ mt: 0.3, fontSize: 13 }}
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "26px",
            }}
            variant="body2"
          >
            {count}
          </Typography>
        </Grid>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            padding: "0 7px 0px 0px",
            // position: "absolute",
            // right: "16px",
            // top: "16px",
          }}
        >
          <img className="fbmetrictilesvg" src={image} />
        </Typography>
      </Paper>
    </Grid>
  );
};

const TicketMetricsTileCount = (props: any) => {
  const { ReportsTicketsTotalCountsData, TicketMetricsTileCount } = props;

  const formatNumber = (num: any) => {
    if (num >= 1e9) {
      return (num / 1e9).toFixed(1) + "B";
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(1) + "M";
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1) + "K";
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return num.toString();
    }
  };
  return (
    <>
      <Tile
        image={images.Alltickets}
        label="Total Tickets"
        tooltipText="Total number of tickets"
        count={formatNumber(TicketMetricsTileCount?.total || 0)}
        // count={ReportsTicketsTotalCountsData?.total || 0}
        svgColor={"#4065F6"}
        svgBg={"#EBEFFE"}
        // count={formatNumber(ReportsTicketsTotalCountsData.sessionIdCount || 0)}
      />
      <Tile
        image={images.newTickets}
        label="New Tickets"
        tooltipText="Tickets that have new status"
        count={formatNumber(TicketMetricsTileCount?.data?.new || 0)}
        svgColor={"#25467C"}
        svgBg={"#FDF3EA"}
        // count={formatNumber(
        //   ReportsTicketsTotalCountsData.totalMessageCount || 0
        // )}
      />
      <Tile
        image={images.ActiveTickets}
        label="In progress Tickets"
        tooltipText="Tickets which are in progress"
        count={formatNumber(TicketMetricsTileCount?.data?.inprogress || 0)}
        // count={formatNumber(
        //   ReportsTicketsTotalCountsData.botAnsweredCount || 0
        // )}
        svgColor={"#89D8B3"}
        svgBg={"#EFFAF4"}
        // count={
        //   (ReportsTicketsTotalCountsData?.data?.inprogress || 0) +
        //   (ReportsTicketsTotalCountsData?.data?.pending || 0)
        // }
      />
      <Tile
        image={images.ClosedTickets}
        label="Closed Tickets"
        tooltipText="Tickets that have closed status"
        count={formatNumber(TicketMetricsTileCount?.data?.closed || 0)}
        svgColor={"#E34050"}
        svgBg={"#e3e3e35e"}
        // count={formatNumber(
        //   ReportsTicketsTotalCountsData.promptToRaiseTicketCount || 0
        // )}
      />
      {/* <Tile
        image={images.ClosedTickets}
        label="Total CSM"
        tooltipText="Tickets that have closed status"
        count={ReportsTicketsTotalCountsData?.data?.closed || 0}
        svgColor={"#E34050"}
        svgBg={"#e3e3e35e"}
        // count={formatNumber(
        //   ReportsTicketsTotalCountsData.promptToRaiseTicketCount || 0
        // )}
      />
      <Tile
        image={images.ClosedTickets}
        label="Total Managers"
        tooltipText="Tickets that have closed status"
        count={ReportsTicketsTotalCountsData?.data?.closed || 0}
        svgColor={"#E34050"}
        svgBg={"#e3e3e35e"}
        // count={formatNumber(
        //   ReportsTicketsTotalCountsData.promptToRaiseTicketCount || 0
        // )}
      /> */}
    </>
  );
};

export default TicketMetricsTileCount;
